<template>
  
  
           
    <div class="w-table-wrap">
       <w-flex class="mt4">
        <div class="xs12 text-right">
          <w-button dark class="green--bg ml1" @click="add()">
            <w-icon class="mr1">fal fa-plus</w-icon> Tambah
          </w-button>
        </div>
      </w-flex>
      <table class="w-table " >

      <thead>
        <tr>
          <th class="w-table__header v2  text-left" width="1%" rowspan="2">No</th>
          <th class="w-table__header v2  text-left" rowspan="2">Tarikh</th>
          <th class="w-table__header v2  text-left" rowspan="2">Pegawai Pemeriksaan</th>
          <th class="w-table__header v2  text-left" rowspan="2">Umur</th>
          <th class="w-table__header v2  text-left" rowspan="2">Berat (kg)</th>
          <th class="w-table__header v2  text-left" rowspan="2">Skor Badan (1-8)</th>
          <th class="w-table__header v2  text-left" rowspan="2">Fizikal (AM)</th>
          <th class="w-table__header v2  text-left" rowspan="2">Ukurlilit Skroktum(cm)</th>
          <th class="w-table__header v2  text-center" colspan="4">Organ Genital Luaran</th>
          <th class="w-table__header v2  text-center" colspan="3">Organ Genital Dalaman</th>
          <th class="w-table__header v2  text-left" rowspan="2">Ulasan</th>
          <th class="w-table__header v2  text-left" rowspan="2">Catatan</th>
          <th class="w-table__header v2  text-left" rowspan="2">Tindakan</th>
        </tr>
        <tr>
          <th class="w-table__header v2  text-left">Testis</th>
          <th class="w-table__header v2  text-left">Epididymis</th>
          <th class="w-table__header v2  text-left">Korda Spermatik</th>
          <th class="w-table__header v2  text-left">Prepuce / Penis</th>
          <th class="w-table__header v2  text-left">Ampullae</th>
          <th class="w-table__header v2  text-left">Kelenjar Vesikal</th>
          <th class="w-table__header v2  text-left">Kelenjar Prostat</th>
        </tr>
      </thead>

      <tbody>
        <template v-if="datas.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell v2 text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in datas">
          <tr class="w-table__row" >
            <td class="w-table__cell v2 text-left" >{{ind+1}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.tarikh}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.user}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.umur}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.berat}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.skor}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.fizikal}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.ukur_lilit}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.testis}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.epididymis}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.korda}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.penis}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.ampullae}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.kelenjar_vesikal}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.kelenjar_prostat}}</td>
            
            <td class="w-table__cell v2 text-left" >{{dt.ulasan}}</td>
            <td class="w-table__cell v2 text-left" >{{dt.catatan}}</td>
            <td class="w-table__cell v2 text-left" >
              <w-button class="fs-2" bg-color="error-dark1" dark tile @click="padam(dt)">
                <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
              </w-button>
            </td>
            
          </tr>
        </template>
      </tbody>
    </table>
  </div>
  <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent"  
    :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
    <template #title>
      <!-- <w-icon class="mr2">fal fa-list</w-icon> -->
       Tambah Fertiliti
    </template>
    <w-form  ref="form"  v-model="dialog.valid" @validate="submit" @success="success" >
      <w-flex wrap>
        <div class="xs6 pa1">
          <div class="spacer"></div>
          <z-input label="Tarikh *" type="date" v-model="form.tarikh"  :validators="[validators.required]" />
          <z-input label="Umur *" v-model="form.umur" disabled :validators="[validators.required]" />
          <z-input label="Berat *" type="number" v-model="form.berat" :validators="[validators.required]" />
          <br>
          <div class="spacer"><b>Organ Genital Luaran * :</b></div>
          <br>
          <z-input label="Testis" type="text" v-model="form.testis" />
          <z-input label="Epididymis" type="text" v-model="form.epididymis" />
          <z-input label="Korda Spermatik" type="text" v-model="form.korda" />
          <z-input label="Prepuce / Penis" type="text" v-model="form.penis" />
        </div>
        <div class="xs6 pa1">
          <!-- <z-select class="mt4" :items="skor" label="Skor *"  v-model="form.skor"  :validators="[validators.required]"/> -->
          <z-input label="Skor*"  type="number" placeholder="Sila Masukan skor 1 - 8" v-model="form.skor" :validators="[validators.required]" />
          <z-input label="Fizikal (AM)*" v-model="form.fizikal" :validators="[validators.required]" />
          <z-input label="Ukurlilit Skroktum(cm)*" type="number" v-model="form.ukur_lilit" :validators="[validators.required]" />
          <br>
          <div class="spacer"><b>Organ Genital Dalaman * :</b></div>
          <br>
          <z-input label="Ampullae" type="text" v-model="form.ampullae" />
          <z-input label="Kelenjar Vesikal" type="text" v-model="form.kelenjar_vesikal" />
          <z-input label="Kelenjar Prostat" type="text" v-model="form.kelenjar_prostat" />
        </div>
      </w-flex>
      <w-textarea 
          outline 
          label="Ulasan "
          placeholder="Sila Masukan ulasan"
          class="mt3"
          name="ulasan"
          v-model="form.ulasan"
          type="text-area"/>
      <w-textarea 
          outline 
          label="Catatan *"
          placeholder="Sila Masukan catatan"
          class="mt3"
          name="catatan"
          v-model="form.catatan"
          type="text-area"
          :validators="[validators.required]"/>
    </w-form>
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="tutupmodal()">Tutup</w-button>
      <w-button class="my1" type="submit" @click="submit()">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> Simpan
      </w-button>
    </template>
  </w-dialog>

</template>

<script>
export default {
  name: "Pemilik",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'ternakan',
      form : {},
      datas : [],
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1200,
      },
      skor:[
        {value: 1, label: "1"},{value: 2, label: "2"},{value: 3, label: "3"},{value: 4, label: "4"},{value: 5, label: "5"},{value: 6, label: "6"},{value: 7, label: "7"},{value: 8, label: "8"}
      ],
      validators: {
          required: (value) => !!value || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
      },
    }
  },
  methods:{
    add(){
      const startDate = new Date(this.data.tarikh_lahir);
      const currentDate = new Date();

      let yearsDifference = currentDate.getFullYear() - startDate.getFullYear();
      let monthsDifference = currentDate.getMonth() - startDate.getMonth();
      if (monthsDifference < 0) {
        yearsDifference--;
        monthsDifference += 12;
      }
      var totalMonths = '';
      if (yearsDifference > 0) {
          var totalMonths = `${yearsDifference} tahun ${monthsDifference} bulan`;
      } else {
          var totalMonths = `${monthsDifference} bulan`;
      }
      this.form = {
           id : null,
           tarikh : currentDate,
           umur: totalMonths,
           berat: '',
           skor: '',
           fizikal: '',
           ukur_lilit: '',
           testis:'',
           epididymis:'',
           korda:'',
           penis:'',
           ampullae:'',
           kelenjar_vesikal:'',
           kelenjar_prostat:'',
           ulasan: '',
           catatan : '',
           ternakan_id: '',
      }
      this.dialog.show = true
      this.form.saveButton = "Save"
    },
    tutupmodal(){
      this.dialog.show= false
    },
    submit(){
      this.form.ternakan_id = this.data.ternakan_id;
      if (this.data.ternakan_id > 0) 
      {
        this.$zcomm.add(this.resourceurl + '.fertiliti_jantan', this.form)
        .then(res => {
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          this.$zutil.notify("Berjaya disimpan");
          this.dialog.show = false;
          this.getData();
        })
      }
    },
    padam(dt){
      if (confirm('Adakah anda pasti untuk memadam rekod ini?')) {
            this.$zcomm.delete(this.resourceurl + '.fertiliti_jantand', dt.id)
                .then(res => {
                  //update displayed record
                  this.$zutil.notify("Berjaya dipadam", false);
                  this.getData();
                  // this.$inertia.visit(this.$page.url)
                  // this.removeitem(res) // remove the data from list. no need to refresh page
                  if (typeof this.onAfterDelete === "function") {
                    this.onAfterDelete()
                  }
                })
                .finally(() => {
                  // $('#' + this.resourceurl).modal('hide')
                });
        }
    },
    getData(){
      this.$zcomm.get(this.api_service + 'ternakan/ferteliti_jantan/'+this.data.ternakan_id, {}).then(res => {
        this.datas = res
      })
    },
    
  },
      
  mounted() {
    this.getData()
    
  }
}
      

</script>  
<style type="text/css">
  
/*.w-table{table-layout: fixed;}*/
.w-table-wrap{ overflow-x: scroll; }
th.v2{
  font-size: 8px !important;
}

td.v2{
  font-size: 8px !important;
}
</style>
